<template>
  <nav>
    <div class="fill-height" :class="mobileOverride() ? 'activity-page-container-mobile' : 'activity-page-container'">
      <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />

      <!-- show draft tag -->
      <v-row v-if="!published && role == 'booster' && !loadingData && !mobile()" no-gutters
        class="text-right custom-draft-tag  custom-draft-tag-style-more-right">
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip data-testid="draft-available-chip" color="warning" text-color="black" v-on="on">
                {{ $t('draftQuizAvailableTag') }}
              </v-chip>
            </template>
            <span>{{ $t('draftQuizAvailableTooltip') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!-- end show draft tag -->
      <!-- show empty page template -->
      <v-row v-if="!listQuestions.length && !loadingData && role == 'booster'" class="greyactivitybackground fill-height"
        no-gutters>
        <v-col cols="12" class="mr-n2" :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''">
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView" />
          </div>
          <v-tabs v-model="tabs" right slider-color="white" slider-size="0px"
            :background-color="!mobile() ? 'greyactivitybackground' : ''" active-class="tab-version-active"
            class="mx-auto fill-height view-quiz overflow-hidden" data-testid="show-tabs" :class="screen">
            <v-tab href="#publish" v-if="published" v-show="!mobile()" style="border-radius: 8px 8px 0 0"
              class="tab-version publish">
              {{ $t('published') }}
            </v-tab>
            <v-tab href="#draft" v-if="!published" v-show="!mobile()" style="color: #fbc02d; border-radius: 8px 8px 0 0"
              class="tab-version draft">
              {{ $t('draft') }}
            </v-tab>

            <v-tabs-items v-model="tabs" :class="!mobile() ? 'rounded-xxl' : 'fill-height'">
              <v-tab-item value="publish" key="publish" :transition="false" reverse-transition="false" style=""
                class="fill-height">
                <EmptyPageActivity elevation="0" class="mx-auto fill-height" align="center"
                  :page-title="$t('emptyActivityQuizTitle')" :page-text="$t('emptyActivityQuizText')" page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''" />
              </v-tab-item>
              <v-tab-item value="draft" key="draft" :transition="false" reverse-transition="false"
                :style="!mobile() ? 'border:2px solid #FBC02D;' : ''" :class="!mobile() ? 'rounded-xxl' : ''">
                <EmptyPageActivity elevation="0" class="mx-auto fill-height" align="center"
                  :page-title="$t('emptyActivityQuizTitle')" :page-text="$t('emptyActivityQuizText')" page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''" />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
      <!-- noPublishedItems -->
      <v-row v-if="noPublishedItems == true && !loadingData && role != 'booster'" class="fill-height" align="center">
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''" align="center">
          <EmptyPage :page-title="$t('noPublishedItemsTitle')" :page-text="$t('noPublishedItemsText')"
            page-image="image4" />
        </v-col>
      </v-row>
      <!-- end noPublishedItems -->
      <!-- locked content -->
      <v-row v-if="!loadingData && lockedContent && !noPublishedItems && role != 'booster'"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2 fill-height' : 'mr-n2 fill-height'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''">
          <LockedContent max-width="960px" elevation="0" class="fill-height" :content="requiredContent"
            :type="lockType" />
        </v-col>
      </v-row>
      <!-- end locked content -->
      <!-- view quiz as a anonymoous -->
      <v-row v-if="role != 'booster' && !loadingData && !noPublishedItems && !isAuth"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''">
          <LockActivityPage max-width="960px" elevation="0" class="mx-auto fill-height" align="center"
            data-testid="lockactivitypage" />
        </v-col>
      </v-row>
      <!-- end view quiz as a anonymoous -->
      <!-- view quiz as a booster -->
      <v-row v-if="role == 'booster' && !loadingData && numberQuestions > 0 && isAuth"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''">
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView" />
          </div>
          <v-tabs v-model="tabs" right slider-color="white" slider-size="0px"
            :background-color="!mobile() ? 'greyactivitybackground' : ''" active-class="tab-version-active"
            class="mx-auto fill-height view-quiz overflow-hidden" data-testid="show-tabs" :class="screen">
            <v-tab href="#publish" v-if="published" v-show="!mobile()" style="border-radius: 8px 8px 0 0"
              class="tab-version publish" data-testid="published-tab">
              {{ $t('published') }}
            </v-tab>
            <v-tab href="#draft" v-if="!published" v-show="!mobile()" style="color: #fbc02d; border-radius: 8px 8px 0 0"
              class="tab-version draft" data-testid="draft-tab">
              {{ $t('draft') }}
            </v-tab>

            <v-tabs-items v-model="tabs" :class="!mobile() ? 'rounded-xxl' : 'fill-height'">
              <v-tab-item v-if="published" value="publish" key="publish" :transition="false" reverse-transition="false"
                :style="!mobile() ? 'border:2px solid #F4F5F5;' : ''">
                <v-card v-if="questionIndexDisplay == 0" data-testid="view-quiz" elevation="0"
                  class="py-12 mx-auto fill-height rounded-xxl" align="center" ref="viewPage"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''">
                  <v-col align="center">
                    <img class="mx-auto quiz-start-image-view"
                      :src="startUrl ? startUrl : require('../../assets/quiz_start.png')" />
                    <h4>{{ quizTitle }}</h4>
                    <v-card-subtitle v-if="numberQuestions > 1" class="text-body-1">
                      {{ numberQuestions }} {{ $t('questionsInTotal') }}
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="text-body-1">
                      {{ numberQuestions }} {{ $t('questionInTotal') }}
                    </v-card-subtitle>
                  </v-col>
                  <v-btn data-testid="view-quiz-button" color="darktext"
                    class="rounded-xxl text-none white--text px-4 my-2" @click="next()">
                    {{ $t('viewQuiz') }}
                  </v-btn>
                </v-card>

                <v-card v-else elevation="0" class="mx-auto fill-height rounded-xxl" align="center"
                  :key="currentQuestion.qid" :class="{ 'mobile-view-simulator-quiz rounded-b-0': screen == 'mobile-view' }"
                  :style="mobile() ? 'margin-bottom: 105px !important' : ''">
                  <v-col>
                    <v-card-text>
                      {{ $t('question') }} {{ currentQuestion.position }}/{{ numberQuestions }}
                    </v-card-text>
                    <h5>{{ currentQuestion.question }}</h5>
                    <div class="my-6">
                      <v-img v-if="currentQuestion.imageDisplay != null" width="100%" max-width="400px"
                        :src="currentQuestion.imageDisplay != null ? currentQuestion.imageDisplay : null" />
                    </div>
                    <div class="answer-section">
                      <v-card-text v-if="currentQuestion.typeAnswer != null" :class="mobileOverride() ? 'pa-0' : ''">
                        <v-row v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex" align="center"
                          :class="mobileOverride() ? '' : 'mb-3'">
                          <v-col cols="12" class="py-1 px-2">
                            <v-text-field v-if="currentQuestion.type == 1" readonly data-testid="answer-input" solo
                              hide-details="auto" class="rounded-xxl text-body-2"
                              :class="{ 'selected-booster': answer.isTrue == true, 'mx-5': !mobileOverride() }">
                              <template v-slot:prepend-inner>
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob' : 'icon-des'" color="greytext">
                                  mdi-radiobox-marked
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob' : 'icon-des'">
                                  mdi-radiobox-blank
                                </v-icon>
                                <p v-if="!mobileOverride()" data-testid="select-answer"
                                  class="pa-4 mb-0 font-weight-regular align-middle greytext--text">
                                  {{ answer.answer }}
                                </p>
                                <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                                  {{ answer.answer }}
                                </h5>
                              </template>
                            </v-text-field>
                            <v-text-field v-else readonly data-testid="answer-input" solo hide-details="auto"
                              class="rounded-xxl text-body-2"
                              :class="{ 'selected-booster': answer.isTrue == true, 'mx-5': !mobileOverride() }">
                              <template v-slot:prepend-inner>
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob' : 'icon-des'" color="greytext">
                                  mdi-checkbox-outline
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob' : 'icon-des'">
                                  mdi-checkbox-blank-outline
                                </v-icon>
                                <p v-if="!mobileOverride()" data-testid="select-answer"
                                  class="pa-4 mb-0 font-weight-regular greytext--text">
                                  {{ answer.answer }}
                                </p>
                                <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                                  {{ answer.answer }}
                                </h5>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-else :class="mobileOverride() ? 'pa-0' : ''">
                        <v-row align="center" justify="center">
                          <v-col v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex"
                            data-testid="answer-input" :class="{ 'selected-booster': answer.isTrue == true }"
                            class="row-pointer" align="center" align-md="left" :cols="mobileOverride() ? '6' : '12'"
                            :sm="mobileOverride() ? '4' : '12'" :md="mobileOverride() ? '6' : '4'" lg="4">
                            <v-card rounded="xxl" width="250px" color="greyactivitybackground">
                              <v-row v-if="currentQuestion.type == 1" align="center" justify="center" class="row-pointer"
                                :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input">
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="greytext">
                                  mdi-radiobox-marked
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                                  mdi-radiobox-blank
                                </v-icon>
                                <v-img data-testid="select-answer" class="rounded-lg text-center align-center"
                                  :class="mobileOverride() ? 'mx-1' : 'mx-3'"
                                  :max-width="mobileOverride() ? '120' : '180'" :width="mobileOverride() ? '120' : '180'"
                                  :height="mobileOverride() ? '90' : '106'"
                                  :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                              </v-row>
                              <v-row v-else align="center" justify="center" class="row-pointer"
                                :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input">
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="greytext">
                                  mdi-checkbox-outline
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                                  mdi-checkbox-blank-outline
                                </v-icon>
                                <v-img data-testid="select-answer" class="rounded-lg text-center align-center"
                                  :class="mobileOverride() ? 'mx-1' : 'mx-3'"
                                  :max-width="mobileOverride() ? '120' : '180'" :width="mobileOverride() ? '120' : '180'"
                                  :height="mobileOverride() ? '90' : '106'"
                                  :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </div>
                    <v-row v-if="!mobileOverride()">
                      <v-col fixed align="center">
                        <v-btn v-if="questionIndexDisplay > 0" data-testid="previous-button" outlined elevation="0"
                          class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
                          {{ $t('previous') }}
                        </v-btn>

                        <v-btn v-if="questionIndexDisplay != 0 && (questionIndexDisplay <= numberQuestions - 1)"
                          data-testid="next-button" color="darktext"
                          class="rounded-xxl text-none white--text px-4 my-4 mx-4" @click="next()">
                          {{ $t('next') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
                <v-footer v-if="screen == 'mobile-view' && questionIndexDisplay > 0"
                  class="white pa-0 rounded-bl-xxl rounded-br-xxl">
                  <v-col fixed align="center" class="pa-0 border-top-simulator-footer">
                    <v-btn v-if="questionIndexDisplay > 0" data-testid="previous-button" outlined elevation="0"
                      class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
                      {{ $t('previous') }}
                    </v-btn>

                    <v-btn v-if="currentQuestion.position != 0 && (currentQuestion.position <= numberQuestions - 1)"
                      data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-4 mx-4"
                      @click="next()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-footer>
              </v-tab-item>
              <v-tab-item v-if="!published" value="draft" key="draft" :transition="false" reverse-transition="false"
                :style="!mobile() ? 'border:2px solid #FBC02D;' : ''" :class="!mobile() ? 'rounded-xxl' : ''">
                <v-card v-if="questionIndexDisplay == 0" data-testid="view-quiz" elevation="0"
                  class="py-12 mx-auto fill-height rounded-xxl" align="center"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''">
                  <v-col align="center">
                    <img class="mx-auto quiz-start-image-view"
                      :src="startUrl ? startUrl : require('../../assets/quiz_start.png')" />
                    <h4>{{ quizTitle }}</h4>
                    <v-card-subtitle v-if="numberQuestions > 1" class="text-body-1">
                      {{ numberQuestions }} {{ $t('questionsInTotal') }}
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="text-body-1">
                      {{ numberQuestions }} {{ $t('questionInTotal') }}
                    </v-card-subtitle>
                  </v-col>
                  <v-btn data-testid="view-quiz-button" color="darktext"
                    class="rounded-xxl text-none white--text px-4 my-2" @click="next()">
                    {{ $t('viewQuiz') }}
                  </v-btn>
                </v-card>

                <v-card v-else elevation="0" class="pb-12 mx-auto fill-height rounded-xxl" align="center"
                  :key="currentQuestion.qid"
                  :class="{ 'mobile-view-simulator-quiz rounded-b-0': screen == 'mobile-view', 'mb-12': mobile() }">
                  <v-col>
                    <v-card-text>
                      {{ $t('question') }} {{ currentQuestion.position }}/{{ numberQuestions }}
                    </v-card-text>
                    <h5>{{ currentQuestion.question }}</h5>
                    <div class="my-6">
                      <v-img v-if="currentQuestion.imageDisplay != null" width="100%" max-width="400px"
                        :src="currentQuestion.imageDisplay != null ? currentQuestion.imageDisplay : null" />
                    </div>
                    <div class="answer-section">
                      <v-card-text v-if="currentQuestion.typeAnswer != null" :class="mobileOverride() ? 'pa-0' : ''">
                        <v-row v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex" align="center"
                          :class="mobileOverride() ? '' : 'mb-3'">
                          <v-text-field v-if="currentQuestion.type == 1" readonly data-testid="answer-input" solo
                            hide-details="auto"
                            :class="{ 'selected-booster': answer.isTrue == true, 'mx-5': !mobileOverride() }"
                            class="rounded-xxl text-body-2">
                            <template v-slot:prepend-inner>
                              <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                :class="mobileOverride() ? 'icon-mob' : 'icon-des'" color="greytext">
                                mdi-radiobox-marked
                              </v-icon>
                              <v-icon v-else data-testid="select-answer"
                                :class="mobileOverride() ? 'icon-mob' : 'icon-des'">
                                mdi-radiobox-blank
                              </v-icon>
                              <p v-if="!mobileOverride()" data-testid="select-answer"
                                class="pa-4 mb-0 font-weight-regular align-middle greytext--text">
                                {{ answer.answer }}
                              </p>
                              <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                                {{ answer.answer }}
                              </h5>
                            </template>
                          </v-text-field>
                          <v-text-field v-else readonly data-testid="answer-input" solo hide-details="auto"
                            :class="{ 'selected-booster': answer.isTrue == true, 'mx-5': !mobileOverride() }"
                            class="rounded-xxl text-body-2">
                            <template v-slot:prepend-inner>
                              <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                :class="mobileOverride() ? 'icon-mob' : 'icon-des'" color="greytext">
                                mdi-checkbox-outline
                              </v-icon>
                              <v-icon v-else data-testid="select-answer"
                                :class="mobileOverride() ? 'icon-mob' : 'icon-des'">
                                mdi-checkbox-blank-outline
                              </v-icon>
                              <p v-if="!mobileOverride()" data-testid="select-answer"
                                class="pa-4 mb-0 font-weight-regular greytext--text">
                                {{ answer.answer }}
                              </p>
                              <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                                {{ answer.answer }}
                              </h5>
                            </template>
                          </v-text-field>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-else>
                        <v-row align="center" justify="center">
                          <v-col v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex"
                            align="center" align-md="left" :cols="mobileOverride() ? '6' : '12'"
                            :sm="mobileOverride() ? '4' : '12'" :md="mobileOverride() ? '6' : '4'">
                            <v-card rounded="xxl" width="250px" color="greyactivitybackground">
                              <v-row v-if="currentQuestion.type == 1" align="center" justify="center" class="row-pointer"
                                :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input">
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="greytext">
                                  mdi-radiobox-marked
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                                  mdi-radiobox-blank
                                </v-icon>
                                <v-img data-testid="select-answer" class="rounded-lg text-center align-center"
                                  :class="mobileOverride() ? 'mx-1' : 'mx-3'"
                                  :max-width="mobileOverride() ? '120' : '180'" :width="mobileOverride() ? '120' : '180'"
                                  :height="mobileOverride() ? '120' : '106'"
                                  :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                              </v-row>
                              <v-row v-else align="center" justify="center" class="row-pointer"
                                :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input">
                                <v-icon v-if="answer.isTrue" data-testid="select-answer" :disabled="published == true"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="greytext">
                                  mdi-checkbox-outline
                                </v-icon>
                                <v-icon v-else data-testid="select-answer"
                                  :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                                  mdi-checkbox-blank-outline
                                </v-icon>
                                <v-img data-testid="select-answer" class="rounded-lg text-center align-center"
                                  :class="mobileOverride() ? 'mx-1' : 'mx-3'"
                                  :max-width="mobileOverride() ? '120' : '180'" :width="mobileOverride() ? '120' : '180'"
                                  :height="mobileOverride() ? '90' : '106'"
                                  :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </div>

                    <v-row v-if="!mobileOverride()">
                      <v-col fixed align="center">
                        <v-btn v-if="questionIndexDisplay > 0" data-testid="previous-button" outlined elevation="0"
                          class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
                          {{ $t('previous') }}
                        </v-btn>

                        <v-btn v-if="questionIndexDisplay != 0 && (questionIndexDisplay <= numberQuestions - 1)"
                          data-testid="next-button" color="darktext"
                          class="rounded-xxl text-none white--text px-4 my-4 mx-4" @click="next()">
                          {{ $t('next') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
                <v-footer v-if="screen == 'mobile-view' && questionIndexDisplay > 0" class="white pa-0 rounded-b-xxl">
                  <v-col fixed align="center" class="pa-0 border-top-simulator-footer">
                    <v-btn v-if="questionIndexDisplay > 0" data-testid="previous-button" outlined elevation="0"
                      class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
                      {{ $t('previous') }}
                    </v-btn>

                    <v-btn v-if="currentQuestion.position != 0 && (currentQuestion.position <= numberQuestions - 1)"
                      data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-4 mx-4"
                      @click="next()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-footer>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>


      <!-- view quiz questions as participant or guest -->
      <v-row
        v-if="(role == 'participant' || role == 'guest') && !loadingData && isAuth && !lockedContent && !noPublishedItems"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'fill-height px-3 mr-n2' : 'fill-height mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : 'background-color: #FFFFFF;'">
          <!-- show start quiz page -->
          <v-card v-if="!startQuiz && completedQuiz == true && result == null" data-testid="start-quiz-card"
            max-width="960px" elevation="0" :rounded="!mobile() ? 'xxl' : ''" class=" mx-auto fill-height"
            :class="mobile() ? 'py-16' : 'py-12'" align="center">
            <v-col align="center">
              <img class="mx-auto quiz-start-image-view"
                :src="startUrl ? startUrl : require('../../assets/quiz_start.png')" />
              <h4>{{ quizTitle }}</h4>
              <v-card-subtitle v-if="numberQuestions > 1" class="text-body-1">
                {{ numberQuestions }} {{ $t('questionsInTotal') }}
              </v-card-subtitle>
              <v-card-subtitle v-else class="text-body-1">
                {{ numberQuestions }} {{ $t('questionInTotal') }}
              </v-card-subtitle>
              <v-btn v-if="numberQuestions > 0 || allowedAttempts == 0" data-testid="start-button" color="darktext"
                class="rounded-xxl text-none white--text px-4 my-2" @click="startQuizFunc()">
                {{ $t('startQuiz') }}
              </v-btn>
            </v-col>
          </v-card>

          <v-card
            v-if="(completedQuiz == true && result != null && !showResult && equalAttemps == true) || (completedQuiz == true && result != null && !showResult)"
            class="fill-height mx-auto " max-width="960px" elevation="0" :rounded="!mobile() ? 'xxl py-12' : 'py-16'"
            align="center">
            <v-row class="fill-height" align="center">
              <v-col v-if="scoreToPess == false" fill-height align="center">
                <div align="center" data-testid="result-block">
                  <h4>{{ $t('yourResult') }}</h4>
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_natural.png" />
                  </v-col>
                  <v-col cols="12">
                    <h4>{{ correct_answers }}/{{ questions_count }} {{ $t('points') }}</h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: allowedAttempts - attempts }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else fill-height align="center">
                <div align="center" data-testid="result-block">
                  <h4>{{ $t('yourResult') }}</h4>
                </div>
                <v-row v-if="minPassScore <= scoreQuiz && !loadingData">
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_celebrate.png" />
                  </v-col>
                  <v-col cols="12">
                    <p data-testid="text-pass">
                      {{ $t('yourResultDescriptionPass') }}
                    </p>
                    <h4 class="green--text">
                      {{ correct_answers }}/{{ questions_count }} {{ $t('points') }}
                    </h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: (allowedAttempts - attempts) }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts && scoreToPess == true">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_sad.png" />
                  </v-col>
                  <v-col cols="12">
                    <p data-testid="text-faild">
                      {{ $t('yourResultDescriptionFailed') }}
                    </p>
                    <h4 class="red--text">
                      {{ correct_answers }}/{{ questions_count }} {{ $t('points') }}
                    </h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: (allowedAttempts - attempts) }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts && scoreToPess == true">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                    <!-- <v-col v-if="numberAttempts > 0"> -->

                    <!-- </v-col> -->
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <!-- notCompleted -->
          <v-card v-if="completedQuiz != true && quizData != null && continueNextQuestion == false" max-width="960px"
            :rounded="!mobile() ? 'xxl' : ''" elevation="0" class="mx-auto fill-height"
            :class="mobile() ? 'py-16' : 'py-12'">
            <v-col data-testid="block-not-complete-quiz" align="center">
              <v-icon size="16em" color="warning" class="mx-auto mt-10 v-list-item__icon">
                mdi-exclamation-thick
              </v-icon>
              <h4>{{ $t('notCompleted') }}</h4>
              <v-row>
                <v-col cols="12">
                  <p>{{ $t('notCompletedDescription') }}</p>
                  <v-btn data-testid="continue-button" color="darktext"
                    class="rounded-xxl text-none white--text px-4 my-2" @click="continueQuizFunc()">
                    {{ $t('continueBtn') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card>

          <!-- show quiz questions -->
          <v-card v-else-if="startQuiz" max-width="960px" elevation="0" :rounded="!mobile() ? 'xxl' : ''"
            class="mx-auto  fill-height" :class="mobile() ? 'pt-16' : 'py-12 px-4'" align="center" :key="currentQuestion.qid"
            :style="mobile() && !showResult ? 'margin-bottom :89px !important;' : ''">
            <v-col v-if="showQuestion">
              <div v-if="showFeedbackCorrect" data-testid="feedback-correct">
                <v-card class="rounded-xxl pa-8" color="#EAFEFB">
                  <v-img width="100%" max-width="120px" class="mx-auto" src="../../assets/icon-celebrate.png" />
                  <v-card-text class="darktext--text pa-0 mt-4 text-left feedback-text">
                    {{ currentQuestion.feedback_correct_answer }}
                  </v-card-text>
                </v-card>
              </div>
              <div v-if="showFeedbackWrong" data-testid="feedback-wrong">
                <v-card class="rounded-xxl pa-8" color="#FDEBEF" >
                  <v-img width="100%" max-width="120px" class="mx-auto" src="../../assets/icon-brainstorm.png" />
                  <v-card-text class="darktext--text pa-0 mt-4 text-left feedback-text">
                    {{ currentQuestion.feedback_wrong_answer }}
                  </v-card-text>
                </v-card>
              </div>
              <div v-if="showFeedbackCorrect || showFeedbackWrong" class="d-flex mt-15">
                <div>
                  <v-img v-if="currentQuestion.imageDisplay != null" width="100%" max-width="100px" class="mr-3"
                    :src="currentQuestion.imageDisplay != null ? currentQuestion.imageDisplay : null" />
                </div>
                <div class="d-flex flex-column">
                  <v-card-text class="pa-0 text-left font-weight-bold">
                    {{ $t('question') }} {{ currentQuestion.position }}/{{ numberQuestions }}
                  </v-card-text>
                  <p class="text-left">{{ currentQuestion.question }}</p>
                </div>
              </div>
              <div v-else>
                <v-card-text>
                  {{ $t('question') }} {{ currentQuestion.position }}/{{ numberQuestions }}
                </v-card-text>
                <h5>{{ currentQuestion.question }}</h5>
                <div class="my-6">
                  <v-img v-if="currentQuestion.imageDisplay != null" width="100%" max-width="400px"
                    :src="currentQuestion.imageDisplay != null ? currentQuestion.imageDisplay : null" />
                </div>
              </div>
              <div class="answer-section">
                <v-card-text v-if="currentQuestion.typeAnswer != null" :class="mobileOverride() ? 'pa-0' : ''">
                  <v-row v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex" align="center"
                    class="mobileOverride() ? '' : 'mb-5'" @click="showFeedbackCorrect || showFeedbackWrong ? '' : selectOption(answerIndex)">
                    <v-col cols="12" class="py-1 px-2">
                      <v-text-field v-if="currentQuestion.type == 1"
                        :class="{ 'selected': answer.isTrue == true, 'mx-5': !mobileOverride() , 'selected-correct': correctAnswers.includes(answer.aid) ,  'selected-wrong': wrongAnswers.includes(answer.aid)  }" 
                        readonly
                        data-testid="answer-input" solo hide-details="auto" class="rounded-xxl text-body-2 row-pointer">
                        <template v-slot:prepend-inner>
                          <v-icon v-if="answer.isTrue" data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob row-pointer' : 'icon-des row-pointer'" color="accent">
                            mdi-radiobox-marked
                          </v-icon>
                          <v-icon v-else data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob row-pointer' : 'icon-des row-pointer'">
                            mdi-radiobox-blank
                          </v-icon>
                          <p v-if="!mobileOverride()" data-testid="select-answer"
                            class="pa-4 mb-0 font-weight-regular align-middle greytext--text row-pointer">
                            {{ answer.answer }}
                          </p>
                          <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                            {{ answer.answer }}
                          </h5>
                        </template>
                      </v-text-field>
                      <v-text-field v-else :class="{ 'selected': answer.isTrue == true, 'mx-5': !mobileOverride(), 'selected-correct': correctAnswers.includes(answer.aid) ,  'selected-wrong': wrongAnswers.includes(answer.aid) }"
                        readonly data-testid="answer-input" solo hide-details="auto"
                        class="rounded-xxl text-body-2 row-pointer">
                        <template v-slot:prepend-inner>
                          <v-icon v-if="answer.isTrue" data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob row-pointer' : 'icon-des row-pointer'" color="accent">
                            mdi-checkbox-outline
                          </v-icon>
                          <v-icon v-else data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob row-pointer' : 'icon-des row-pointer'">
                            mdi-checkbox-blank-outline
                          </v-icon>
                          <p v-if="!mobileOverride()" data-testid="select-answer"
                            class="pa-4 mb-0 font-weight-regular greytext--text row-pointer">
                            {{ answer.answer }}
                          </p>
                          <h5 v-else data-testid="select-answer" class="pa-3 font-weight-regular greytext--text">
                            {{ answer.answer }}
                          </h5>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-else :class="mobileOverride() ? 'pa-0' : ''">
                  <v-row align="center" justify="center">
                    <v-col v-for="(answer, answerIndex) in currentQuestion.options" :key="answerIndex"
                      :class="{ 'selected': answer.isTrue == true }" align="center" align-md="left" class="row-pointer"
                      :cols="mobileOverride() ? '6' : '12'" :md="mobileOverride() ? '6' : '4'"
                      :sm="mobileOverride() ? '4' : '12'" lg="4">
                      <v-card rounded="xxl" width="250px" color="greyactivitybackground"
                      :class="{ 'selected-correct': correctAnswers.includes(answer.aid) ,  'selected-wrong': wrongAnswers.includes(answer.aid)  }"
                      >
                        
                        <v-row v-if="currentQuestion.type == 1" align="center" justify="center" class="row-pointer"
                          :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input"
                          
                          @click="showFeedbackCorrect || showFeedbackWrong ? '' : selectOption(answerIndex)">
                          <v-icon v-if="answer.isTrue" data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="accent">
                            mdi-radiobox-marked
                          </v-icon>
                          <v-icon v-else data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                            mdi-radiobox-blank
                          </v-icon>
                          <v-img data-testid="select-answer" class="rounded-lg text-center align-center"
                            :class="mobileOverride() ? 'mx-2' : 'mx-3'" :max-width="mobileOverride() ? '120' : '180'"
                            :width="mobileOverride() ? '120' : '180'" :height="mobileOverride() ? '90' : '106'"
                            :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                        </v-row>
                        <v-row v-else align="center" justify="center" class="row-pointer"
                          :class="mobileOverride() ? 'pa-2' : 'pa-3'" data-testid="answer-input"
                          @click="showFeedbackCorrect || showFeedbackWrong ? '' : selectOption(answerIndex)">
                          <v-icon v-if="answer.isTrue" data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'" color="accent">
                            mdi-checkbox-outline
                          </v-icon>
                          <v-icon v-else data-testid="select-answer"
                            :class="mobileOverride() ? 'icon-mob mx-0 mx-sm-8' : 'icon-des'">
                            mdi-checkbox-blank-outline
                          </v-icon>
                          <v-img data-testid="select-answer" class="rounded-lg text-center align-center mx-3"
                            :class="mobileOverride() ? 'mx-1' : 'mx-3'" :max-width="mobileOverride() ? '120' : '180'"
                            :width="mobileOverride() ? '120' : '180'" :height="mobileOverride() ? '90' : '106'"
                            :src="answer.imageDisplay != null ? answer.imageDisplay : null" />
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
              <v-row v-if="!mobileOverride()">
                <v-col v-if="showFeedbackCorrect || showFeedbackWrong" fixed align="center">
                  <v-btn data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-2"
                    @click="feedbackNextQuestion()">
                    {{ $t('nextQuestion') }}
                  </v-btn>
                </v-col>
                <v-col v-else fixed align="center">
                  <v-btn data-testid="skip-button" :class="{ 'disable-events': skipButton }" outlined elevation="0"
                    class="rounded-xxl text-none mr-8 px-4 my-2" @click="answerQuestion('skip')">
                    {{ $t('skip') }}
                  </v-btn>
                  <v-btn :disabled="answerButton" data-testid="answer-button" color="darktext"
                    class="rounded-xxl text-none white--text px-4 my-2" @click="answerQuestion('answer')">
                    {{ $t('answer') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!-- show result -->
            <v-row v-if="showResult" class="fill-height" align="center">
              <v-col v-if="scoreToPess == false" fill-height align="center">
                <div align="center" data-testid="result-block">
                  <h4>{{ $t('yourResult') }}</h4>
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_natural.png" />
                  </v-col>
                  <v-col cols="12">
                    <h4>{{ correct_answers }}/{{ questions_count }} {{ $t('points') }}</h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: (allowedAttempts - attempts) }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts && allowedAttempts != 0">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else fill-height align="center">
                <div align="center" data-testid="result-block">
                  <h4>{{ $t('yourResult') }}</h4>
                </div>
                <v-row v-if="minPassScore <= scoreQuiz && !loadingData">
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_celebrate.png" />
                  </v-col>
                  <v-col cols="12">
                    <p data-testid="text-pass">
                      {{ $t('yourResultDescriptionPass') }}
                    </p>
                    <h4 class="green--text">
                      {{ correct_answers }}/{{ questions_count }} {{ $t('points') }}
                    </h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: (allowedAttempts - attempts) }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts && allowedAttempts != 0">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col cols="12">
                    <v-img width="100%" max-width="240px" class="mx-auto" src="../../assets/emotion_sad.png" />
                  </v-col>
                  <v-col cols="12">
                    <p data-testid="text-faild">
                      {{ $t('yourResultDescriptionFailed') }}
                    </p>
                    <h4 class="red--text">
                      {{ correct_answers }}/{{ questions_count }} {{ $t('points') }}
                    </h4>
                    <br>
                    <p v-if="(allowedAttempts - attempts) > 0">
                      {{ $t('yourResultAttempts', { numberAttempts: (allowedAttempts - attempts) }) }}
                    </p>
                    <br>
                    <p v-if="allowedAttempts == attempts && allowedAttempts != 0">
                      {{ $t('yourResultNoMoreAttempts') }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-btn v-if="(allowedAttempts - attempts) > 0 || allowedAttempts == 0" data-testid="retry-button"
                      outlined elevation="0" class="rounded-xxl text-none px-4 my-2" @click="retry()">
                      {{ $t('retry') }}
                    </v-btn>
                    <!-- <v-col v-if="numberAttempts > 0"> -->

                    <!-- </v-col> -->
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <EditButtonWithLinkInActivity v-if="isAuth && role == 'booster' && !loadingData && !mobile()"
        data-testid="edit-activity-quiz-button" rounded="xxl" :class="editButtonTextColor" :color="editButtonColor"
        :link="{ title: '', route: '/activity/' + $route.params.id + '/quiz/' + $route.params.quizId + '/edit' }"
        @openPreventEditingDialog="dialogVisible = true" />
      <v-card ref="viewNavigationButtons" max-width="960px" elevation="0" class="mx-auto"
        v-if="role != 'booster' && !loadingData && showQuestion == false">
        <NavigationBackButton :activity-pages="activity_pages" />
        <NavigationNextButton :activity-pages="activity_pages" />
      </v-card>
      <ConfirmationDialog v-if="dialogVisible" ref="confirmationDialog" :visible="dialogVisible"
        :cd-title="confirmationDialogTitle" :cd-text="confirmationDialogText" :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn" :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="confirmation-dialog" @close="dialogVisible = false" @proceedSubmit="dialogVisible = false" />
    </div>
    <v-footer v-if="mobile() && showQuestion == true && role != 'booster'" fixed class="white">
      <v-col v-if="showFeedbackCorrect || showFeedbackWrong" fixed align="center">
        <v-btn data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-2"
          @click="feedbackNextQuestion()">
          {{ $t('nextQuestion') }}
        </v-btn>
      </v-col>
      <v-col v-else fixed align="center">
        <v-btn data-testid="skip-button" :class="{ 'disable-events': skipButton }" outlined elevation="0"
          class="rounded-xxl text-none mr-8 px-4 my-2" @click="answerQuestion('skip')">
          {{ $t('skip') }}
        </v-btn>
        <v-btn :disabled="answerButton" data-testid="answer-button" color="darktext"
          class="rounded-xxl text-none white--text px-4 my-2" @click="answerQuestion('answer')">
          {{ $t('answer') }}
        </v-btn>
      </v-col>
    </v-footer>
    <v-footer v-if="mobile() && role == 'booster' && questionIndexDisplay > 0" fixed class="white">
      <v-col fixed align="center">
        <v-btn v-if="questionIndexDisplay > 0" data-testid="previous-button" outlined elevation="0"
          class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
          {{ $t('previous') }}
        </v-btn>

        <v-btn v-if="currentQuestion.position != 0 && (currentQuestion.position <= numberQuestions - 1)"
          data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-4 mx-4"
          @click="next()">
          {{ $t('next') }}
        </v-btn>
      </v-col>
    </v-footer>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getActivity, getActivityPages, getActivityQuiz, getQuizQuestions, quizAttempt, quizAttemptDetails, completeActivityQuiz, questionAnswer, getQuestion, getImageURLsInActivityQuiz } from '../../api/activityApi'
import { eventBus } from '../../eventbus'
import EmptyPage from '../../components/EmptyPage'
import EmptyPageActivity from '../../components/EmptyPageActivity'
import NavigationNextButton from '../../components/NavigationNextButton'
import LockActivityPage from '../../components/LockActivityPage'
import EditButtonWithLinkInActivity from '../../components/EditButtonWithLinkInActivity'
import AlertMessages from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import LockedContent from '../../components/LockedContent'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import moment from 'moment'
import NavigationBackButton from '../../components/NavigationBackButton'
import ActivityViewToggle from '../../components/ActivityViewToggle'

export default {
  components: {
    EmptyPage,
    EmptyPageActivity,
    EditButtonWithLinkInActivity,
    AlertMessages,
    NavigationNextButton,
    LockActivityPage,
    LockedContent,
    ConfirmationDialog,
    NavigationBackButton,
    ActivityViewToggle
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      isAuth: window.$cookies.get("token") ? true : false,
      checkboxCertificate: false,
      loadingData: false,
      spaceId: window.$cookies.get('space_id'),
      activityId: this.$route.params.id,
      pageId: this.$route.params.pageId,
      quizId: this.$route.params.quizId,
      scormId: this.$route.params.scormId,
      alertMsg: '',
      alertValue: false,
      alertType: '',
      activity_pages: [],
      role: '',
      hasActivityAccess: false,
      published: false,
      editButtonColor: 'warning',
      editButtonTextColor: 'black--text',
      startQuiz: false,
      quizTitle: '',
      numberQuestions: '',
      questionIndex: 0,
      questionIndexDisplay: 0,
      currentQuestion: {},
      listQuestions: [],
      answers: [],
      quizIdAttempt: null,
      showQuestion: false,
      showResult: false,
      answerButton: true,
      skipButton: true,
      selected: false,
      scoreQuiz: 0,
      minPassScore: 0,
      scoreToPess: false,
      noPublishedItems: false,
      allowedAttempts: 0,
      attempts: 0,
      completedQuiz: true,
      lastquestion: null,
      nextquestion: null,
      quizData: null,
      maxAttemps: false,
      equalAttemps: false,
      correct_answers: 0,
      questions_count: 0,
      continueNextQuestion: false,
      lockedContent: false,
      requiredContent: {},
      result: null,
      pageExist: true,
      dialogVisible: false,
      confirmationDialogTitle: i18n.t('confirmationDialogTitlePreventEdit'),
      confirmationDialogText: i18n.t('confirmationDialogTextPreventEdit'),
      confirmationDialogSubmitBtn: i18n.t('ok'),
      confirmationDialogCancelBtn: i18n.t('cancel'),
      cdSubmitBtnColor: 'accent',
      showForum: true,
      tabs: 'publish',
      lockType: null,
      screen: 'desktop-view',
      startUrl: null,
      startPath: null,
      showFeedbackCorrect: false,
      showFeedbackWrong: false,
      correctAnswers: [],
      wrongAnswers: []
    }
  },

  async beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPrevRoute(from);
    })
  },

  async created() {
    if (this.$route.params.successfullyCreatedActivity) {
      this.alertMsg = i18n.t('createActivitySuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityPage) {
      this.alertMsg = i18n.t('createActivityPageSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityQuiz) {
      this.alertMsg = i18n.t('createActivityQuizSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyAddedActivityScorm) {
      this.alertMsg = i18n.t('createActivityScormSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityChecklist) {
      this.alertMsg = i18n.t('createActivityChecklistSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivitySurvey) {
      this.alertMsg = i18n.t('createActivitySurveySuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyPublishedActivityQuiz) {
      this.alertMsg = i18n.t('publishActivityQuizSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyUpdatedUnpublishedActivityQuiz) {
      this.alertMsg = i18n.t('editQuizDraftSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyUpdatedPublishedActivityQuiz) {
      this.alertMsg = i18n.t('editQuizSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullySharedActivity) {
      this.alertMsg = i18n.t('shareActivitySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDeletedActivityPage) {
      this.alertMsg = i18n.t('deleteActivityPageSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDeletedActivityQuiz) {
      this.alertMsg = i18n.t('deleteActivityQuizSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivityScorm) {
      this.alertMsg = i18n.t('deleteActivityScormSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivityChecklist) {
      this.alertMsg = i18n.t('deleteActivityChecklistSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivitySurvey) {
      this.alertMsg = i18n.t('deleteActivitySurveySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDuplicatedActivity) {
      this.alertValue = true
      this.alertType = 'success'
      this.alertMsg = i18n.t('duplicateActivitySuccess')
    }
    if (this.$route.params.boostersAddedInActivity) {
      this.alertMsg = i18n.t('addActivityBoostersSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyConnectedActivityEduAdmin) {
      this.alertMsg = i18n.t("eduAdminConnectedActivitySuccess");
      this.alertType = "success";
      this.alertValue = true;
    }

    if (this.$route.params.preventEditing) {
      this.dialogVisible = true
    }

    this.loadingData = true
    this.lockedContent = false

    this.equalAttemps = false

    this.quizId = this.$route.params.quizId

    await this.getActivityPages()

    await this.getActivity()

    await this.getActivityQuizQuestions()
    if ((this.role == 'participant' || this.role == 'guest') && this.hasActivityAccess) {
      eventBus.$emit('changeNavigationInActivity', this.activity_pages)
      await this.getQuizAttemptDetails()
    }

    this.loadingData = false
  },

  methods: {
    mobileOverride() {
      if (this.screen == 'mobile-view') {
        return true;
      } else {
        return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
      }
    },
    changeView(val) {
      this.screen = val
    },
    retry() {
      this.result = null
      this.startQuiz = false
      this.getActivityQuizQuestions()
    },
    prev() {
      if (this.questionIndex == this.numberQuestions) {

        this.questionIndexDisplay = this.questionIndex - 1
        this.questionIndex--

      } else {
        this.questionIndexDisplay--

      }

      if (this.questionIndex == 0) {
        this.questionIndex = 1
      }
      this.questionIndex--

      if (this.questionIndex == this.questionIndexDisplay) {
        if (this.questionIndex == 0) {
          this.questionIndex = 1
        }
        this.questionIndex--
      }

      this.getQuestion(this.listQuestions[this.questionIndex])

    },
    next() {

      if (this.questionIndex < this.questionIndexDisplay) {
        this.questionIndex++
      }

      this.getQuestion(this.listQuestions[this.questionIndex])

      if (this.questionIndex <= this.numberQuestions - 1) {
        this.questionIndex++

      }

      this.questionIndexDisplay++

    },
    async startQuizFunc() {
      this.startQuiz = true
      this.skipButton = false
      try {
        let data = {
          data: {
            type: "quiz-attempts",
            attributes: {
            },

            relationships: {
              quiz: {
                data: {
                  type: "quizzes",
                  id: this.quizId
                }
              }
            }
          }
        };
        const response = await quizAttempt(data);
        if (response) {
          if (response.status == 201) {
            this.quizIdAttempt = response.data.data.id
            await this.getQuestion(this.listQuestions[this.questionIndex])
            this.showQuestion = true

          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 422) {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          } else if (e.response.status == 403) {
            // this.$router.push({name: 'PageAccessDenied'})
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async continueQuizFunc() {
      this.startQuiz = true
      this.skipButton = false
      this.continueNextQuestion = true
      if (this.nextquestion == null && this.lastquestion != null) {
        await this.getQuestion(this.lastquestion)
      } else if (this.lastquestion != null && this.nextquestion != null) {
        await this.getQuestion(this.nextquestion)
      } else if (this.lastquestion == null) {
        await this.getQuestion(this.nextquestion)
      }
      this.showQuestion = true
    },
    async getQuizAttemptDetails() {
      try {
        const response = await quizAttemptDetails(this.quizId)
        if (response.status == 200) {
          this.quizData = response.data.data
          this.lastquestion = response.data.meta.last_question
          this.nextquestion = response.data.meta.next_question
          this.completedQuiz = response.data.meta.completed
          this.quizIdAttempt = response.data.data.id
          this.result = response.data.data.attributes.result
          if (this.result != null) {
            this.correct_answers = response.data.data.attributes.result.correct_answers
            this.questions_count = response.data.data.attributes.result.questions_count
            this.scoreQuiz = response.data.data.attributes.result.score
            this.scoreToPess = response.data.data.attributes.result.has_passing_score
            this.minPassScore = response.data.data.attributes.result.min_passing_score
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertType = 'error';
            this.alertMsg = i18n.t('dataNotRetrievedError')
          }
        }
      }
    },
    async getQuestion(index) {
      try {
        const response_question = await getQuestion(index)
        if (response_question.status == 200) {
          var responseQuestionImageURL = await this.changeImageURLs(response_question.data.data.attributes.image)
          var options = []
          for (const answer of response_question.data.data.attributes.options) {
            var responseAnswerImageURL = await this.changeImageURLs(answer.image)
            if (this.role != 'booster') {
              options.push(
                {
                  aid: answer.aid,
                  answer: answer.answer,
                  image: answer.image,
                  imageDisplay: responseAnswerImageURL,
                  isTrue: false
                }
              )
            } else {
              options.push(
                {
                  aid: answer.aid,
                  answer: answer.answer,
                  image: answer.image,
                  imageDisplay: responseAnswerImageURL,
                  isTrue: answer.isTrue
                }
              )

            }
          }

          this.correctAnswers = []
          this.wrongAnswers = []
          
          this.currentQuestion = {
            qid: response_question.data.data.id,
            id: response_question.data.data.id,
            question: response_question.data.data.attributes.question,
            image: response_question.data.data.attributes.image,
            imageDisplay: responseQuestionImageURL,
            type: response_question.data.data.attributes.type,
            typeAnswer: options[0].answer,
            options: options,
            position: response_question.data.data.attributes.position,
            feedback_wrong_answer: response_question.data.data.attributes.feedback_wrong_answer,
            feedback_correct_answer: response_question.data.data.attributes.feedback_correct_answer
          }
          this.skipButton = false
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 422) {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          } else if (e.response.status == 403) {
            ///this.$router.push({name: 'PageAccessDenied'})
          } else if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }

      }
    },
    async answerQuestion(option) {
      this.skipButton = true
      this.answerButton = true
      if (option == 'skip') {
        this.answers = []
      }
      try {
        let data = {
          data: {
            type: "question-attempts",
            attributes: {
              answer: this.answers

            },
            relationships: {
              quiz: {
                data: {
                  type: "quizzes",
                  id: this.quizId
                }
              },
              question: {
                data: {
                  type: "questions",
                  id: this.currentQuestion.qid
                }
              },
              "quiz-attempt": {
                data: {
                  type: "quiz-attempts",
                  id: this.quizIdAttempt
                }
              }
            },
          }
        };
        const response = await questionAnswer(data);
        if (response) {
          if (response.status == 201) {
            // if (this.currentQuestion.feedback_correct_answer != null || this.currentQuestion.feedback_wrong_answer != null) {
              if (option == 'skip'){
                if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
                  this.showQuestion = false
                  this.showResult = true
                  this.completeQuiz()
                }
                if (this.currentQuestion.position < this.numberQuestions && this.numberQuestions > 1) {
                  this.getQuestion(this.listQuestions[this.currentQuestion.position])
                }
              }else {
                this.correctAnswers = response.data.data.attributes.correct_answers
                this.wrongAnswers = response.data.data.attributes.wrong_answers
                if (response.data.data.attributes.result == false) {
                  this.showFeedbackWrong = true
                  if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
                    this.completeQuizShowFeedback()
                  }
                }
                else if (response.data.data.attributes.result == true) {
                  this.showFeedbackCorrect = true
                  if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
                    this.completeQuizShowFeedback()
                  }
                } else {
                  if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
                    this.showQuestion = false
                    this.showResult = true
                    this.completeQuiz()
                  }
                  if (this.currentQuestion.position < this.numberQuestions && this.numberQuestions > 1) {
                    this.getQuestion(this.listQuestions[this.currentQuestion.position])
                  }
                }
              }
            // } else {
            //   if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
            //     this.showQuestion = false
            //     this.showResult = true
            //     this.completeQuiz()
            //   }
            //   if (this.currentQuestion.position < this.numberQuestions && this.numberQuestions > 1) {
            //     this.getQuestion(this.listQuestions[this.currentQuestion.position])
            //   }
            // }

          }
        }
        this.answers = []
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 422) {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          } else if (e.response.status == 403) {
            //this.$router.push({name: 'PageAccessDenied'})
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
        this.skipButton = false
        this.answerButton = false
      }

    },

    async feedbackNextQuestion() {
      if ((this.numberQuestions > 1 && this.currentQuestion.position == this.numberQuestions) || (this.currentQuestion.position != 0 && this.numberQuestions == 1)) {
        this.showQuestion = false
        this.showResult = true
        this.getActivity()
        this.getQuizAttemptDetails()
      }
      if (this.currentQuestion.position < this.numberQuestions && this.numberQuestions > 1) {
        await this.getQuestion(this.listQuestions[this.currentQuestion.position])
      }
      this.showFeedbackCorrect = false
      this.showFeedbackWrong = false
    },


    async completeQuiz() {
      this.loadingData = true
      try {
        let data = {
          data: {
            id: this.quizIdAttempt,
            type: "quiz-attempts",
            attributes: {

            },

            relationships: {
              quiz: {
                data: {
                  type: "quizzes",
                  id: this.quizId
                }
              }
            },
          }
        };
        const response = await completeActivityQuiz(this.quizIdAttempt, data);
        if (response) {
          if (response.status == 200) {
            if (!response.data.data.attributes.result.has_passing_score || (response.data.data.attributes.result.has_passing_score && response.data.data.attributes.result.score >= response.data.data.attributes.result.min_passing_score)) {
              eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
            }

            this.getActivity()
            this.getQuizAttemptDetails()
            this.scoreQuiz = response.data.data.attributes.result.score
            this.correct_answers = response.data.data.attributes.result.correct_answers
            this.scoreToPess = response.data.data.attributes.result.has_passing_score
            this.questions_count = response.data.data.attributes.result.questions_count
            this.minPassScore = response.data.data.attributes.result.min_passing_score
          }
        }

      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 422) {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          } else if (e.response.status == 403) {
            // this.$router.push({name: 'PageAccessDenied'})
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }

      }
      this.loadingData = false
    },

    async completeQuizShowFeedback() {
      this.loadingData = true
      try {
        let data = {
          data: {
            id: this.quizIdAttempt,
            type: "quiz-attempts",
            attributes: {

            },

            relationships: {
              quiz: {
                data: {
                  type: "quizzes",
                  id: this.quizId
                }
              }
            },
          }
        };
        const response = await completeActivityQuiz(this.quizIdAttempt, data);
        if (response) {
          if (response.status == 200) {
            if (!response.data.data.attributes.result.has_passing_score || (response.data.data.attributes.result.has_passing_score && response.data.data.attributes.result.score >= response.data.data.attributes.result.min_passing_score)) {
              eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
            }
            this.scoreQuiz = response.data.data.attributes.result.score
            this.correct_answers = response.data.data.attributes.result.correct_answers
            this.scoreToPess = response.data.data.attributes.result.has_passing_score
            this.questions_count = response.data.data.attributes.result.questions_count
            this.minPassScore = response.data.data.attributes.result.min_passing_score
          }
        }

      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 422) {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          } else if (e.response.status == 403) {
            // this.$router.push({name: 'PageAccessDenied'})
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }

      }
      this.loadingData = false
    },

    selectOption(index) {
      if (this.currentQuestion.type == 1) {
        if (!this.currentQuestion.options[index].isTrue) {
          for (var i = 0; i < this.currentQuestion.options.length; i++) {
            this.currentQuestion.options[i].isTrue = false
          }
          this.currentQuestion.options[index].isTrue = true
          this.answers = [{ "aid": this.currentQuestion.options[index].aid }]
          this.answerButton = false
          this.selected = true
        }
      } else {
        if (!this.currentQuestion.options[index].isTrue) {
          this.currentQuestion.options[index].isTrue = true
          this.answers.push({ "aid": this.currentQuestion.options[index].aid })
          this.answerButton = false
          this.selected = true
        } else {
          const countRightAnswers = this.currentQuestion.options.reduce((counter, obj) => obj.isTrue == true ? counter += 1 : counter, 0);
          //if more that 1 right answers allow to uncheck the checkbox
          if (countRightAnswers > 1) {
            this.currentQuestion.options[index].isTrue = false
            for (var j = 0; j < this.answers.length; j++) {
              if (this.answers[j]['aid'] == this.currentQuestion.options[index].aid) {
                this.answers.splice(j, 1);
              }
            }
          }
        }
      }
    },

    getPrevRoute(data) {
      if (data.name == 'Activitites' || data.name == 'ViewHub' || data.name == 'ViewCategory' || data.name == 'SharedWithMe' || data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' || data.name == 'ActivitiesParticipant') {
        eventBus.$emit('setActivityExitBtn', data)
      }
    },

    async getActivity() {
      try {
        const response = await getActivity(this.activityId)
        if (response.status == 200) {
          this.hasActivityAccess = true
          this.role = response.data.data.attributes.role
          if (response.data.data.attributes.activity_page_id == null) {
            this.noPublishedItems = true
          } else {
            if (!this.pageExist) {
              this.$router.push({ name: 'PageNotFound' })
            } else if (this.role != 'booster' && !this.published) {
              this.$router.push({ name: 'PageAccessDenied' })
            }
            if (this.role && this.role != "NA") {
              if (this.role == 'booster' || ((this.role == 'participant' || this.role == 'guest') && !this.lockedContent)) {
                const response_page = await getActivityQuiz(this.quizId)
                if (response_page.status == 200) {
                  this.checkboxCertificate = response.data.data.attributes.certificate_enabled
                  this.quizTitle = response_page.data.data.attributes.title
                  this.published = response_page.data.data.attributes.published
                  this.allowedAttempts = response_page.data.data.attributes.allowed_attempts
                  this.attempts = response_page.data.data.attributes.attempts

                  if (this.attempts > 0 && this.allowedAttempts > 0) {
                    if (this.attempts === this.allowedAttempts || this.attempts > this.allowedAttempts) {
                      this.equalAttemps = true
                    }
                  }
                  this.editButtonColor = this.published ? "accent" : "warning"
                  this.editButtonTextColor = this.published ? "white--text" : "black--text"

                  this.startPath = response_page.data.data.attributes.start_image
                  this.startUrl = this.startPath ? await this.changeImageURLs(this.startPath) : null
                }
              }
            }
          }

        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 400) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              this.alertValue = true
              if (e.response.data.errors[i].detail == 'Quiz is not published yet') {
                this.alertType = 'error'
                this.alertMsg = i18n.t('quizNotPublished')
              }
              else {
                this.alertType = 'error'
                this.alertMsg = i18n.t('serverError')
              }
            }
          } else if (e.response.status == 404) {
            if (this.isAuth) {
              this.$router.push({ name: 'PageNotFound' })
            } else {
              this.$router.push({ name: 'CustomLogin', query: { referer: this.$route.fullPath } })
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else if(e.response.status != 401) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async getActivityQuizQuestions() {
      this.startQuiz = false
      this.showQuestion = false
      this.showResult = false
      this.continueNextQuestion = false
      this.listQuestions = []
      this.questionIndex = 0
      this.questionIndexDisplay = 0
      this.result = null

      try {
        if ((this.role && this.role != "NA" && this.published && this.hasActivityAccess) || this.role == 'booster') {
          const response = await getQuizQuestions(this.quizId)
          if (response.status == 200) {
            this.numberQuestions = response.data.meta.questions.length
            var questions = response.data.meta.questions
            for (var i = 0; i < questions.length; i++) {
              this.listQuestions.push(questions[i]);
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertValue = true
            this.alertType = 'error';
            this.alertMsg = i18n.t('dataNotRetrievedError')
          }
        }
      }
    },

    async changeImageURLs(value) {
      var imagesToCheck = []
      if (value != null) {
        imagesToCheck = [value]

        let dataImage = {
          data: {
            type: "quizzes",
            id: this.quizId,
            attributes: {
              paths: imagesToCheck,
              space_id: this.spaceId
            }
          }
        };

        const responseImageQuestion = await getImageURLsInActivityQuiz(this.quizId, dataImage)
        return responseImageQuestion.data.meta.files[value]
      } else {
        return null
      }
    },

    async getActivityPages() {
      try {
        const response = await getActivityPages(this.activityId)
        if (response.status == 200) {
          if (!response.data.data.find(page => page.attributes.entity_id == this.quizId && page.attributes.entity_type == 'quiz')) {
            this.pageExist = false
          }
          this.activity_pages = response.data.data.filter(page => page.attributes.is_published == true)
          if (this.activity_pages.find(page => page.attributes.entity_id == this.quizId && page.attributes.entity_type == 'quiz')) {
            this.published = true
          }
          var requiredPageId = this.activity_pages.find(page => page.attributes.entity_id == this.quizId && page.attributes.entity_type == 'quiz').attributes.rule_item_id
          var requiredPageStatus = this.activity_pages.find(page => page.attributes.entity_id == this.quizId && page.attributes.entity_type == 'quiz').attributes.rule_fulfilled
          var requiredDate = this.activity_pages.find(page => page.attributes.entity_id == this.quizId && page.attributes.entity_type == 'quiz').attributes.rule_available_after

          if (requiredPageId != null && requiredPageStatus == false) {
            this.lockedContent = true
            this.requiredContent = this.activity_pages.find(page => page.id == requiredPageId)
            this.lockType = "feedItemDependent"
          } else if (requiredDate != null && requiredPageStatus == false) {
            this.lockedContent = true
            this.requiredContent = { date: moment(requiredDate).format('YYYY-MM-DD') + ' ' + moment(requiredDate).format('HH:mm') }
            this.lockType = "dateDependent"
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
    }
  },
}
</script>
<style scope>
.answer-section .v-input__control .v-input__slot .v-text-field__slot {
  display: none !important;
}

.answer-section .image-null {
  display: none;
}

.v-input__prepend-inner .v-icon.v-icon.icon-des {
  align-items: inherit !important;
  margin-top: 0.45em;
}

.answer-section .v-input__prepend-inner .v-icon.v-icon.icon-mob {
  align-items: inherit !important;
  margin-top: 10px;
}

.answer-section .selected .v-input__slot,
.answer-section .selected .v-card {
  border: 1px solid var(--v-accent-base) !important;
}

.answer-section .selected-booster .v-input__slot,
.answer-section .selected-booster .v-card {
  border: 1px solid var(--v-greytext-base);
}

.answer-section .row-pointer:hover {
  cursor: pointer;
}

.answer-section .selected-correct .v-input__slot,
.answer-section .selected-correct .v-card,
.answer-section .selected-correct.v-card {
  border: 1px solid var(--v-success-base) !important;
}

.answer-section .selected-wrong .v-input__slot,
.answer-section .selected-wrong .v-card,
.answer-section .selected-wrong.v-card {
  border: 1px solid var(--v-error-base) !important;
}

.feedback-text {
  white-space: pre-line;
}
</style>